import React   from "react";
import { Input, Select, TextArea, DateInput } from "@components/form";
import { FormProvider } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate  } from 'react-router-dom';
import { useLectureForm } from '@hooks';
import DaySchedule from './DaySchedule';


const LectureForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { selectedLectureId, isEdit } = location.state || {};
  const { methods, categoryList, eduTypeList, instructorList, createLecture, updateLecture,
          dayFields, removeDay, 
    } = useLectureForm({ isEdit, selectedLectureId });

  const { handleSubmit, setValue, watch } = methods;
  const showSchedule = watch("firstDt"); // 날짜 선택 여부

  const firstDt = watch("firstDt");
  const lastDt  = watch("lastDt") || firstDt; 
  const today   = new Date();
  today.setHours(0,0,0,0);  

  const endDate = lastDt ? new Date(lastDt) : null;
  const readOnly = isEdit && endDate && today > endDate;

  const onSubmit = async (formData) => {

      if (isEdit) {
        await updateLecture(formData);
        alert("강의 수정이 완료되었습니다.");
      } else {
        await createLecture(formData);
        alert("강의 등록이 완료되었습니다.");
      }

      await queryClient.invalidateQueries({ queryKey: ["selectAdminLectureList"] });

      navigate('/master/lecture');
  };

  const onError = () => {
    alert("필수 입력란을 확인하세요.");
  }

  const handleBackList = () => {
    const isConfirmed = window.confirm("목록으로 돌아가시겠습니까? 입력한 정보는 저장 되지 않습니다.");
    if (!isConfirmed) return;

    navigate("/master/lecture");
  };

  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        setValue("zipcode", data.zonecode, { shouldValidate: true });
        setValue("address1", data.address, { shouldValidate: true });
      },
    }).open();
  };


  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-gradient-square"></span>{isEdit ? '교육 수정' : '교육 등록'}</h2>
            <div className="section-tit-wrap" style={{marginRight:'7px'}}>
              <div className="btn-right-box">
                <ul>
                  <li><button type="button" title="목록" className="btn-excel" onClick={handleBackList}>목록</button></li>
                  <li><button type="submit" title="저장" className="btn-save">저장</button></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
                <section className="wr-form">
                  <div className="table-container">
                  <table className="table-write" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "30%" }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>강의명<span className="red">*</span></th>
                        <td>
                          <Input name="lectureNm" className="input-text" placeholder="강의명" style={{ width: "100%" }}/>
                        </td>
                        <th>교육분류{!isEdit && <span className="red">*</span>}</th>
                        <td>
                          <Select
                            name="eduCategoryId"
                            className="input-select"
                            defaultOption="선택"
                            options={categoryList?.result}
                            valueKey="eduCategoryId"
                            labelKey="eduCategoryNm"
                            rules={isEdit ? {} : { required: true }}
                            disabled={isEdit}
                          />
                        </td>
                        <th>교육유형{!isEdit && <span className="red">*</span>}</th>
                        <td>
                          <Select
                            name="eduType"
                            className="input-select"
                            defaultOption="선택"
                            options={eduTypeList?.result}
                            valueKey="comdCode"
                            labelKey="comdName"
                            rules={isEdit ? {} : { required: true }}
                            disabled={isEdit}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>강의일(첫날)<span className="red">*</span></th>
                        <td>
                        <DateInput 
                          name="firstDt"
                          style={{width:"100%"}}
                          rules={{ required:true }}
                          disabled={readOnly} />
                        </td>
                        <th>강의일(마지막)</th>
                        <td>
                        <DateInput 
                          name="lastDt"
                          style={{width:"100%"}}
                          disabled={readOnly}
                        />
                        </td>
                        <th>신청기간<span className="red">*</span></th>
                        <td>
                        <DateInput 
                          name="applyStartDt"
                          style={{width:"100%"}}
                          rules={{ required:true }}
                          disabled={readOnly} />&nbsp; ~ &nbsp;
                        <DateInput 
                          name="applyEndDt"
                          style={{width:"100%"}}
                          rules={{ required:true }}
                          disabled={readOnly} />
                        </td>

                      </tr>

                      <tr>
                        <th>관련법령</th>
                        <td><Input name="eduLaw" className="input-text" placeholder="관련 법령" style={{ width: "100%" }}/></td>
                        <th>교육목표</th>
                        <td><Input name="eduGoal" className="input-text" placeholder="교육 목표" style={{ width: "100%" }}/></td>
                        <th>출강사업장</th>
                        <td><Input name="companyNm" className="input-text" placeholder="사업장 명" style={{ width: "100%" }}/></td>
                      </tr>
                      <tr>
                        <th>담당자명</th>
                        <td><Input name="managerNm" className="input-text" placeholder="담당자" style={{ width: "100%" }}/></td>
                        <th>담당자 이메일</th>
                        <td><Input name="managerEmail" className="input-text" placeholder="ex)email@example.com" style={{ width: "100%" }}/></td>
                        <th>담당자 전화번호<span className="red">*</span></th>
                        <td><Input name="managerPhoneNo" className="input-text" placeholder="ex)010-1234-5678" rules={{ required:true }} style={{ width: "100%" }}/></td>
                      </tr>

                      <tr>
                        <th>교육시간<span className="red">*</span></th>
                        <td><Input name="eduHours" type="number" className="input-text" placeholder="시간" rules={{ required:true }} style={{ width: "100%" }}/></td>
                        <th>수강료</th>
                        <td><Input name="eduPee" type="number" className="input-text" placeholder="₩" style={{ width: "100%" }}/></td>
                        <th>수강정원<span className="red">*</span></th>
                        <td><Input name="eduStdntLimit" type="number" className="input-text" placeholder="명" rules={{ required:true }} style={{ width: "100%" }}/></td>
                      </tr>
                      <tr>
                        <th>주소</th>
                        <td >
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <div style={{ marginBottom: '8px', display:'flex' }}>
                                <Input
                                  name="zipcode"
                                  placeholder="우편번호"
                                  readOnly
                                  className="input-text"
                                  style={{width:"100%"}}
                                />
                                <button
                                  type="button"
                                  className="btn-add btn-form-search"
                                  onClick={handleAddressSearch}
                                  style={{marginLeft:"10px"}} >
                                  검색
                                </button>
                              </div>
                              <div>
                                <Input
                                  name="address1"
                                  placeholder="주소"
                                  readOnly
                                  className="input-text"
                                  maxLength={30}
                                  style={{width:"100%", marginBottom:"10px"}}
                                />
                                <Input
                                  name="address2"
                                  placeholder="상세주소를 입력하세요"
                                  className="input-text"
                                  maxLength={30}
                                  style={{width:"100%"}}
                                />
                              </div>
                            </div>
                        </td>
                        <th>교육내용</th>
                        <td colSpan={3}>
                        <TextArea
                            name="eduContents"
                            className="area"
                            autoResize
                            placeholder="교육내용.."
                        />
                        </td>
                      </tr>

                  </tbody>
                </table>

                {/* 강의 세부 일정 */}
                {showSchedule && (
                  <>
                    {dayFields.map((day, idx) => (
                      <DaySchedule
                        key={day.id}
                        dayIdx={idx}
                        dayId={day.id}
                        methods={methods}
                        instructorList={instructorList}
                        dayFields={dayFields}
                        removeDay={removeDay}
                        readOnly={readOnly}
                      />
                    ))}
                  </>
                )}

                </div>
                </section>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export {LectureForm};
